
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
declare var openDatabase: any;
declare var window: any;

@Injectable()
export class DalProvider {

  static connection: any;
  constructor() {

  }

  createAndGetConnection(options: any) {
    return new Promise((res, err) => {

      // if (options.storage == "web") {
    
      //   var db = openDatabase(options.database, "", options.description, 25 * 1024 * 1024);
      //   DalProvider.connection = db;
      //   db.transaction(function (tx) {
      //     DalProvider.createDatabase(tx);
      //     res(db)
      //   })
      // }
      // else {
  console.log("db olusacak")
        // var db = window.sqlitePlugin.openDatabase({ name: 'VT.db', location: 'default' }, function (success) {
        //   console.log("db1",db)
        //   DalProvider.connection = db;
        //   db.transaction(function (tx) {
        //     DalProvider.createDatabase(tx);
        //     console.log("db",tx)
        //     res(db)
        //   })
        // }, function (error) { });
     //}
    })

  }


  static createDatabase(tx) {
    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Siparis " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "StokKartID double," +
      "IslemTuru double," +
      "FaturaID double," +
      "SatirNo double," +
      "CariKartID double," +
      "DepoKodu double," +
      "Miktar double," +
      "BirimFiyat double," +
      "IskontoOran1 double," +
      "IskontoOran2 double," +
      "IskontoOran3 double," +
      "IskontoTutar double," +
      "IskontoluBirimFiyati double," +
      "AraTutar double," +
      "Kdv double," +
      "Tutar double," +
      "KdvOran double," +
      "SlsMan double," +
      "Sign double," +
      "SaticiRef double," +
      "Maliyet double," +
      "NetFiyat double," +
      "siparisID double," +
      "UrunName text," +
      "SIPARIS_DURUM_ID double," +
      "Kalan double" +
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_StokKarti " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "Kodu text," +
      "StokAdi text," +
      "Barcode1 text," +
      "Barcode2 text," +
      "Vat double," +
      "KategoriID double," +
      "MarkId double," +
      "VatGrupId double," +
      "Price1 double," +
      "Price2 double," +
      "Price3 double," +
      "Price4 double," +
      "Status double," +
      "WebStatus double," +
      "BirimId double," +
      "Image1 text," +
      "Image2 text," +
      "IsTerazi double," +
      "PLU double," +
      "ParentAktif double,"+
      "FiyatDegisimTarihi text," +
      "MaximumSeviye double," +
      "MinumumSeviye double," +
      "Hit double," +
      "EkranSiraNo double," +
      "Entegrasyon double," +
      "Guncellendi double," +
      "EkranNumarasi double," +
      "YerliMi double," +
      "UlkeID double," +
      "PuanAktif double," +
      "BagliStokID double," +
      "DolarFiyat double," +
      "DovizTipi double," +
      "DovizSimge text" +
      ")");
    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS Vw_Stoklar" +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "Kodu text," +
      "StokAdi text," +
      "Barcode1 text," +
      "Barcode2 text," +
      "Vat double," +
      "KategoriID double," +
      "MarkId double," +
      "VatGrupId double," +
      "Price1 double," +
      "Price2 double," +
      "Price3 double," +
      "Price4 double," +
      "Status double," +
      "WebStatus double," +
      "BirimId double," +
      "Image1 text," +
      "Image2 text," +
      "IsTerazi double," +
      "PLU double," +
      "FiyatDegisimTarihi text," +
      "MaximumSeviye double," +
      "MinumumSeviye double," +
      "Hit double," +
      "EkranSiraNo double," +
      "Giren double," +
      "Cikan double," +
      "Kalan double," +
      "KategoriAdi text," +
      "BirimAdi text," +
      "MarkaAdi text," +
      "SatinAlmaTarihi text," +
      "SatinAlmaGecenGun double," +
      "SatisTarihi text," +
      "SatisGecenGun double," +
      "Entegrasyon double," +
      "ParentAktif double,"+
      "Guncellendi double," +
      "YerliMi double," +
      "UlkeADi text," +
      "DolarFiyat double," +
      "DovizTipi double," +
      "DovizSimge text" +
     
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_CariKart" +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "Kodu text," +
      "Definition_ text," +
      "Addr1 text," +
      "Addr2 text," +
      "Country text," +
      "Email text," +
      "Ilgili text," +
      "TaxOf text," +
      "TaxNumber text," +
      "TelNumber text," +
      "GsmNumber text," +
      "Image text," +
      "Text text," +
      "PuanCardNumber text," +
      "SmsHaber double," +
      "GrupRef double," +
      "RiskLimiti double," +
      "TCK text," +
      "AlisFiyatindanSat double," +
      "SiraNo double," +
      "VadeGunSayisi int," +
      "VadeBitisTarihi text"+
      ")");
    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS Vw_Cariler" +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "Kodu text," +
      "Definition_ text," +
      "Addr1 text," +
      "Addr2 text," +
      "Country text," +
      "Email text," +
      "Ilgili text," +
      "TaxOf text," +
      "TaxNumber text," +
      "TelNumber text," +
      "GsmNumber text," +
      "Image text," +
      "Text text," +
      "PuanCardNumber text," +
      "SmsHaber double," +
      "GrupRef double," +
      "RiskLimiti double," +
      "Borcu double," +
      "Alacagi double," +
      "Bakiyesi double," +
      "KazanilanPuan double," +
      "HarcananPuan double," +
      "KalanPuan double," +
      "AlisFiyatindanSat double," +
      "SiraNo double," +
      "VadeGunSayisi int,"+
      "VadeBitisTarihi text,"+
      "KalanVadegun int"+
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Barcode " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "StokKartID double," +
      "Barcode double" +
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Kasa " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "Kodu text," +
      "Name text," +
      "OdemeTipi double," +
      "YazarKasaIndex text," +
      "ParcaliOdemedeGoster double" +
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Birim " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "BirimName text" +
      ")");
      
    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Subeler " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "SubeAdi text," +
      "SubeAdres text,"+
      "VarsayilanMi double"+
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Kategoriler " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "KategoriAdi text," +
      "Sort double," +
      "BackGround double," +
      "ForeGround double," +
      "DokunmatikMi double" +
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_KDVGrup " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "VatName text," +
      "VatBarcode text" +
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Marka " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "MarkName text" +
      ")");


    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Servis " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "ADRES text," +
      "Tanim text"+
    
      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS RafEtiket " +
      "(" +
      "ID double," +
      "StokKartiID double," +
      "StokAdi text," +
      "Barcode1 text," +
      "Barcode2 text," +
      "Price1 double," +
      "Price2 double," +
      "Price3 double," +
      "Price4 double," +
      "FiyatDegisimTarihi text," +
      "UlkeAdi text," +
      "BirimAdi text," +
      "Miktar double"+

      ")");
    // tx.executeSql(
    //   "CREATE TABLE IF NOT EXISTS KullaniciType " +
    //   "(" +
    //   "ID INTEGER PRIMARY KEY ASC," +
    //   "Type double" +
    //   ")");
    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS App_User" +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "Sifre double," +
      "Name text," +
      "Type doble," +
      "OffMode double" +

      ")");

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_ProgramAyarlari" +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "CariListeSayisi double," +
      "MalzemeListeSayisi double," +
      "SatisFaturasiStoktanDusecekMi double," +
      "fisyazicioto double," +
      "FisYaziciAdi text," +
      "BarkodYaziciAdi text"+
      ")");

      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS NL_Image"+
        "("+
      
        "ID INTEGER PRIMARY KEY ASC," +
        "Image_Type smallint," +
        "Image_Path text," +
        "IMAGE_URL text," +
        "Default_Image smallint," +
        "Source_Ref INTEGER," +
        "Image_Name text," +
        "Image_Ext text," +
        "Title text," +
        "Descr text,"+
        "Spec_Field1 text,"+
        "Spec_Field2 text,"+
        "Spec_Field3 text"+
        ")");

      


  }

  SifirlanacakTablolariSil() {
    return new Promise((res, err) => {
      var db = DalProvider.connection;
      db.transaction(function (tx) {
        tx.executeSql("DROP TABLE IF EXISTS NL_StokKarti");
        tx.executeSql("DROP TABLE IF EXISTS NL_Birim");
        tx.executeSql("DROP TABLE IF EXISTS NL_Kategoriler");
        tx.executeSql("DROP TABLE IF EXISTS NL_KDVGrup");
        tx.executeSql("DROP TABLE IF EXISTS NL_Marka");
        tx.executeSql("DROP TABLE IF EXISTS Vw_Stoklar");
        tx.executeSql("DROP TABLE IF EXISTS NL_CariKart");
        tx.executeSql("DROP TABLE IF EXISTS Vw_Cariler");
        tx.executeSql("DROP TABLE IF EXISTS M_REMEMBER_ACC");

        // res();
      });
    })

  }
  PerakendeSatisSifirlama() {
    return new Promise((res, err) => {
      var db = DalProvider.connection;
      db.transaction(function (tx) {
        tx.executeSql("DROP TABLE IF EXISTS NL_StokKarti");
        tx.executeSql("DROP TABLE IF EXISTS NL_Birim");
        tx.executeSql("DROP TABLE IF EXISTS NL_Kategoriler");
        tx.executeSql("DROP TABLE IF EXISTS NL_KDVGrup");
        tx.executeSql("DROP TABLE IF EXISTS NL_Marka");
        tx.executeSql("DROP TABLE IF EXISTS Vw_Stoklar");
        tx.executeSql("DROP TABLE IF EXISTS NL_CariKart");
        tx.executeSql("DROP TABLE IF EXISTS Vw_Cariler");
        tx.executeSql("DROP TABLE IF EXISTS NL_Kasa");

        // res();
      });
    })

  }
  StoklarviewSil() {
    return new Promise((res, err) => {
      var db = DalProvider.connection;
      db.transaction(function (tx) {

        tx.executeSql("DROP TABLE IF EXISTS Vw_Stoklar");


        // res();
      });
    })

  }



}



// WEBPACK FOOTER //
// ./src/providers/dal/dal.ts